import { render, staticRenderFns } from "./contentful-rich-text.vue?vue&type=template&id=12b79d9e&scoped=true&"
import script from "./contentful-rich-text.vue?vue&type=script&lang=js&"
export * from "./contentful-rich-text.vue?vue&type=script&lang=js&"
import style0 from "./contentful-rich-text.vue?vue&type=style&index=0&id=12b79d9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b79d9e",
  null
  
)

export default component.exports